import { api, apiGet, apiPost, apiPut, apiDelete } from "./api";

export interface BlogAuthor {
  id: number;
  username: string;
  profilePhoto: string | null;
}

export interface BlogPost {
  id: number;
  slug: string;
  title: string;
  excerpt?: string | null;
  content: string;
  coverImage?: string | null;
  metaDescription?: string | null;
  isPublished: boolean;
  publishedAt?: string | null;
  createdAt: string;
  updatedAt: string;
  author?: BlogAuthor | null;
}

export interface BlogListResult {
  posts: BlogPost[];
  pagination: { page: number; totalPages: number; total: number };
}

export interface BlogPostInput {
  title: string;
  slug?: string;
  excerpt?: string | null;
  content: string;
  coverImage?: string | null;
  metaDescription?: string | null;
  isPublished?: boolean;
}

export const blogService = {
  // ---- Public ----
  async listPublic(page = 1, limit = 12): Promise<BlogListResult> {
    const response = await api.get("/blog", { params: { page, limit } });
    return {
      posts: response.data.data || [],
      pagination: response.data.pagination || { page: 1, totalPages: 1, total: 0 },
    };
  },

  async getBySlug(slug: string): Promise<BlogPost> {
    return apiGet<BlogPost>(`/blog/${slug}`);
  },

  // ---- Admin ----
  async listAdmin(): Promise<BlogPost[]> {
    return apiGet<BlogPost[]>("/blog/admin/posts");
  },

  async getAdmin(id: number): Promise<BlogPost> {
    return apiGet<BlogPost>(`/blog/admin/posts/${id}`);
  },

  async create(data: BlogPostInput): Promise<BlogPost> {
    return apiPost<BlogPost>("/blog/admin/posts", data);
  },

  async update(id: number, data: Partial<BlogPostInput>): Promise<BlogPost> {
    return apiPut<BlogPost>(`/blog/admin/posts/${id}`, data);
  },

  async remove(id: number): Promise<void> {
    await apiDelete(`/blog/admin/posts/${id}`);
  },

  async uploadImage(file: File): Promise<string> {
    const formData = new FormData();
    formData.append("featuredImage", file);
    const result = await apiPost<{ coverImage: string }>("/blog/admin/upload-image", formData);
    return result.coverImage;
  },
};
